import { ActionTypesUi } from "../constants/action-types"

let initState = {
    config: {},
    player: {},
    error: null,
}

export const uiReducer = (state = initState, { type, payload }) => {

    switch (type) {

        case ActionTypesUi.UI_PULL_ERROR:
            {
                return {
                    ...state,
                    signIn: {
                        error: payload.error,
                    }
                }
            }

        case ActionTypesUi.SET_CHAT_CONFIG:
            {
                return {
                    ...state,
                    config: payload.config
                }
            }
        case ActionTypesUi.SET_PLAYER_DATA:
            {
                return {
                    ...state,
                    player: payload.player
                };
            }

        case ActionTypesUi.PLAYER_PULL_ERROR:
            {
                return {
                    ...state,
                    error: payload.error
                };
            }
        default:
            {
                return state;
            }
    }
}

export default uiReducer;